export default __webpack_public_path__ + "images/XC.44153d6.png";